var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55371 14.9999C2.55371 18.3009 3.865 21.4666 6.19912 23.8007C8.53324 26.1348 11.699 27.4461 14.9999 27.4461C18.3009 27.4461 21.4666 26.1348 23.8007 23.8007C26.1348 21.4666 27.4461 18.3009 27.4461 14.9999C27.4461 11.699 26.1348 8.53324 23.8007 6.19912C21.4666 3.865 18.3009 2.55371 14.9999 2.55371C11.699 2.55371 8.53324 3.865 6.19912 6.19912C3.865 8.53324 2.55371 11.699 2.55371 14.9999Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.223V14.9999",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 8.77673C14.8457 8.77673 14.6953 8.82236 14.5674 8.90783C14.4395 8.99331 14.3398 9.1148 14.2809 9.25694C14.222 9.39908 14.2066 9.55549 14.2366 9.70638C14.2666 9.85728 14.3407 9.99588 14.4495 10.1047C14.5583 10.2135 14.6969 10.2875 14.8478 10.3176C14.9987 10.3476 15.1551 10.3322 15.2973 10.2733C15.4394 10.2144 15.5609 10.1147 15.6464 9.98679C15.7318 9.85887 15.7775 9.70847 15.7775 9.55462C15.7775 9.34831 15.6955 9.15045 15.5496 9.00457C15.4037 8.85869 15.2059 8.77673 14.9996 8.77673Z",
    fill: "#121212",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.80c1d29432ee3a7af597f7e3f0ce0b82.svg";
export { ForwardRef as ReactComponent };